import 'whatwg-fetch'
import 'custom-event-polyfill'
import 'url-polyfill'
import 'core-js/stable/promise'
import 'core-js/stable/symbol'
import 'core-js/stable/string/starts-with'
import 'core-js/web/url'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Vue from 'vue'
import App from './App.vue'
import ViewUI from 'view-design'
import router from './router'
import 'view-design/dist/styles/iview.css'
import './css/format.less'
import './css/mobile.less'
import {
  qdTable,
  qdSearch,
  qdTableBtns,
  qdListEditor,
  qdModals,
} from 'quandou-ui'
import store from './store/index'
import 'amfe-flexible'
import Contextmenu from 'vue-contextmenujs'
Vue.use(Contextmenu)
Vue.use(ViewUI)
Vue.use(qdTable)
Vue.use(qdSearch)
Vue.use(qdTableBtns)
Vue.use(qdModals)
Vue.use(qdListEditor)
Vue.config.productionTip = false

Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
  },
})

let btnCode = window.localStorage.getItem('btnCode')
if (btnCode) {
  Vue.prototype.$bp = JSON.parse(btnCode)
}

new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount('#app')
